// indexedDbStorage.ts
import localforage from "localforage";

const isBrowser = typeof window !== "undefined";

export const IDX_DB_DB_NAME = "myconnect-db";
export const IDX_DB_STORE_NAME = "myconnect-store";
export const IDX_DB_VALUE_KEYS = {
  token: "token",
  authUserState: "auth-user-st",
  userGuide: "userguide",
  profileUserCGPS: "profiles-users-cgps",
  calendarStore: "calendar-store",
  cgPercent: "cg-percent",
  myActivity: "my-activity",
};

if (isBrowser) {
  // Configure localforage only on the client side
  localforage.config({
    driver: [
      localforage.INDEXEDDB,
      localforage.WEBSQL,
      localforage.LOCALSTORAGE,
    ],
    name: IDX_DB_DB_NAME,
    version: 1.0,
    storeName: IDX_DB_STORE_NAME, // name of the table
    description: "MyConnect client-side storage",
  });
}

const mockStorage = {
  setItem: async <T>(key: string, value: T): Promise<T | null> =>
    Promise.resolve(null),
  getItem: async <T>(key: string): Promise<T | null> => Promise.resolve(null),
  removeItem: async (key: string): Promise<void> => Promise.resolve(),
};

export const indexedDbStorage = isBrowser
  ? {
      setItem: async <T>(key: string, value: T): Promise<T | null> => {
        try {
          return await localforage.setItem(key, value);
        } catch (err) {
          console.error("Error setting item in localforage:", err);
          return null;
        }
      },

      getItem: async <T>(key: string): Promise<T | null> => {
        try {
          return await localforage.getItem(key);
        } catch (err) {
          console.error("Error getting item from localforage:", err);
          return null;
        }
      },

      removeItem: async (key: string): Promise<void> => {
        try {
          await localforage.removeItem(key);
        } catch (err) {
          console.error("Error removing item from localforage:", err);
        }
      },
    }
  : mockStorage;

export async function getFromLocalStorage<T>(key: string): Promise<T | null> {
  return await indexedDbStorage.getItem<T>(key);
}

export const clearAllStorage = async () => {
  if (isBrowser) {
    try {
      await Promise.all(
        Object.values(IDX_DB_VALUE_KEYS).map(async (key) => {
          await indexedDbStorage.removeItem(key);
          // Also remove from localStorage for good measure, in case it was stored there previously
          localStorage.removeItem(key);
        })
      );
    } catch (err) {
      console.error("Error clearing storage:", err);
    }
  }
};
